import type { PIIHighlightSpan } from "../types";

export type PiiTextSegment =
  | { type: "text"; content: string }
  | { type: "highlight"; content: string; label: PIIHighlightSpan["label"] };

/** Split message text into plain and PII-highlight segments for rendering. */
export function buildPiiHighlightedSegments(
  text: string,
  highlights?: PIIHighlightSpan[],
): PiiTextSegment[] {
  if (!highlights?.length) {
    return [{ type: "text", content: text }];
  }

  const sorted = [...highlights].sort((a, b) => a.start - b.start);
  const segments: PiiTextSegment[] = [];
  let cursor = 0;

  for (const highlight of sorted) {
    if (highlight.end <= cursor) {
      continue;
    }

    const start = Math.max(highlight.start, cursor);

    if (start > cursor) {
      segments.push({
        type: "text",
        content: text.slice(cursor, start),
      });
    }

    segments.push({
      type: "highlight",
      content: text.slice(start, highlight.end),
      label: highlight.label,
    });
    cursor = highlight.end;
  }

  if (cursor < text.length) {
    segments.push({ type: "text", content: text.slice(cursor) });
  }

  return segments;
}
